import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-netflix',
  templateUrl: './netflix.component.html',
  styleUrls: ['./netflix.component.sass']
})
export class NetflixComponent implements OnInit {
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token: string = sessionStorage.getItem("token");

  public actualViewStep;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router,private loadingScreenService: LoadingScreenService) {
    this.AngularFireAnalytics.setCurrentScreen("Netflix");
    this.AngularFireAnalytics.logEvent("Netflix-Screenview");
  }

  ngOnInit() {
    this.loadingScreenService.stopLoading();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  changeView(view, step) {
    if (this.global.validateSession()) {
      this.router.navigate(['/netflix_subs']);

      /*
      if (view == 'back') {
          // document.getElementById('idTermsAndConditionsNet').checked = true;
      }
      */

      if (step === 0) {
        this.actualViewStep = 'step0';
      } else {
        // validacion de netflix

        if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.Netflix == true) {
          // $state.go('netflix_subs');
          this.router.navigate(['/netflix_subs']);
        }
        else {
          // alertify.set({labels: {ok: 'OK'}});
          //  alertify.alert("<div class='dialogTitle'>Aviso</div><div class='dialogContent'>Disculpa, pero en este momento no podemos ofrecerte el servicio de suscripción a Netflix por medio de la Factura Claro. Si deseas mayor información, te invitamos a comunicarte con un representante de Servicio al cliente.</div>", function () { });
        }
      }
    }
  }
}
